import { useMemo } from 'react'
import { useSystemManagerStore } from '@editor/stores/systemManagerStore'
import { getPlanTables } from '@queries'
import { usedAssemblyGuidsForTemplateTables } from './utils'

/**
 * Query key for plan tables, including template-table sources so the live
 * preview refetches when assemblies or connections change.
 */
const usePlanTablesQueryKey = (projectId?: string) => {
  const assemblies = useSystemManagerStore(state => state.assemblies)
  const assemblyAssignment = useSystemManagerStore(state => state.assemblyAssignment)
  const connections = useSystemManagerStore(state => state.connections)

  const usedAssemblyGuids = useMemo(
    () => usedAssemblyGuidsForTemplateTables(assemblyAssignment),
    [assemblyAssignment],
  )

  return [...getPlanTables.getKey(projectId), assemblies, usedAssemblyGuids, connections]
}

export default usePlanTablesQueryKey
